(function($) {

  const toggles = document.querySelectorAll('.accordion-module__toggle');

  function toggleAccordion(event) {
    event.preventDefault();
    this.parentNode.classList.toggle('open');
  }

  if(toggles) {
    for (let i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', toggleAccordion);
    }
  }

}(jQuery));
